<template>
  <v-card class="pa-0 ma-0 mt-9 pa-8">
    <v-card-title class="ma-0 pa-0 h6 blue-grey--text text--darken-3 mb-1">
      {{ $t('boards.new_board') }}
    </v-card-title>
    <v-card-text class="ma-0 pa-0">
      <p class="body-2 blue-grey--text text-darken-1 mb-4">
        {{ $t('boards.board_description') }}
      </p>
      <v-form
        v-model="formIsValid"
        ref="boardForm"
        @submit.prevent
        lazy-validation
      >
        <v-text-field
          v-model="name"
          outlined
          dense
          counter="60"
          :maxLength="60"
          :label="`${$t('common.name')}*`"
          :rules="[
            name => !!name || $t('validation.form.this_field_is_required'),
          ]"
          @change="e => emitChange(e, 'name')"
        />
        <v-textarea
          v-model="description"
          outlined
          dense
          auto-grow
          no-resize
          rows="3"
          counter="170"
          :maxLength="170"
          :label="`${$t('boards.description_optional')}`"
          @change="e => emitChange(e, 'description')"
        />
      </v-form>
    </v-card-text>
    <v-card-actions class="ma-0 pa-0 mt-4 justify-end">
      <v-btn
        text
        plain
        rounded
        dense
        color="blue-grey darken-1"
        @click="$emit('cancel')"
        >{{ $t('common.button.cancel') }}</v-btn
      >
      <v-btn
        rounded
        dense
        color="blue"
        class="white--text px-4 ms-3"
        elevation="0"
        @click="handleContinue"
        >{{ $t('common.button.continue') }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: 'FormStep',

  data() {
    return { formIsValid: true, name: null, description: '' }
  },

  watch: {
    formIsValid: {
      handler(formIsValid) {
        this.$emit('formIsValid', formIsValid)
      },
    },
  },

  methods: {
    handleContinue() {
      this.$refs.boardForm.validate()
      this.$emit('continue')
    },

    emitChange(value, field) {
      this.$emit('change', value, field)
    },
  },
}
</script>
